<template>
  <div class="columns is-vcentered">
      <div class="column is-3-desktop">
          <a class="has-text-grey-light" 
          v-if="direction.left.length > 0"
          v-tooltip.bottom="{ content: direction.left[direction.left.length - 1] }"
          @click="changeCharacter(false)">
              <fa icon="angle-double-left" class="fa-4x"/>
          </a>
      </div>
      <div class="column is-6-desktop">
          
          <stats v-if="type == 11"
          :api="api" :user="user"
          @go-back="goBack()" />
          <reset v-else-if="type == 12"
          @go-back="goBack()"
          :api="api" :user="user" />
          
      </div>
      <div class="column is-3-desktop">
          <a class="has-text-grey-light" 
          v-if="direction.right.length > 0"
          v-tooltip.bottom="{ content: direction.right[0] }"
          @click="changeCharacter(true)">
              <fa icon="angle-double-right" class="fa-4x"/>
          </a>
      </div>
  </div>
</template>

<script>

import Stats from '@/components/player/characterStats.vue'
import Reset from '@/components/player/characterReset.vue'
export default {
    name:'DashboardCharacterUpdate',
    props: {
        character: {
            default:'',
            type: String
        },
        direction: {
            default:()=>({
                left:[],
                right:[]
            }),
            type:Object
        },
        api: String,
        user: Object,
        type: Number
    },
    components: {
        Stats, Reset
    },
    created() {
        if (!(this.type === 11 || this.type === 12)) this.$router.push('/cuenta/personajes')
    },
    methods: {
        goBack() {
            this.$store.commit('changeDashboardPage', 1)
            this.$router.push('/cuenta/personajes')
        },
        async changeCharacter(dir) {
            var tempRight = this.direction.right,
                tempLeft = this.direction.left,
                tempChar = this.character

            if (dir) {
                tempLeft.push(tempChar)
                tempChar = tempRight[0]
                tempRight.shift()
            } else {
                tempRight.unshift(tempChar)
                tempChar = tempLeft[tempLeft.length - 1]
                tempLeft.pop()
            }

            await this.$store.dispatch('setDashboardData', {direction:{left:tempLeft,right:tempRight}, character:tempChar})
        }
    }
}
</script>

<style>

</style>